import {
  NotificationTypes,
  NotificationNotifyOnStatuses,
  parseAlertEnabled,
} from "../store/modules/alert";

export function alertTypeLabel(notificationType) {
  switch (notificationType) {
    case NotificationTypes.AGENT:
      return "Agent";
    case NotificationTypes.TASK:
      return "Task";
    case NotificationTypes.WORKFLOW:
      return "Workflow";
    default:
      return "—";
  }
}

export function alertTypeColor(notificationType) {
  switch (notificationType) {
    case NotificationTypes.AGENT:
      return "blue";
    case NotificationTypes.TASK:
      return "teal";
    case NotificationTypes.WORKFLOW:
      return "deep-purple";
    default:
      return "grey";
  }
}

export function notifyOnLabel(notificationType, notifyOn) {
  if (notifyOn === 0 || notifyOn === null || notifyOn === undefined) {
    return "Bildirim: tüm sonuçlar";
  }
  if (notifyOn === NotificationNotifyOnStatuses.JOB_FAIL) {
    return "Bildirim: sadece hata";
  }
  if (notifyOn === NotificationNotifyOnStatuses.JOB_SUCCESS) {
    return "Bildirim: sadece başarı";
  }
  return "Bildirim: —";
}

function scriptIdsFromAlert(alert) {
  if (Array.isArray(alert.ScriptIds) && alert.ScriptIds.length) {
    return [...new Set(alert.ScriptIds.filter(Boolean))];
  }
  if (alert.ScriptId) return [alert.ScriptId];
  return [];
}

function workflowIdsFromAlert(alert) {
  if (!Array.isArray(alert.WorkflowIds)) return [];
  return [...new Set(alert.WorkflowIds.filter((id) => id !== null && id !== undefined && id !== "").map(String))];
}

function agentNamesFromAlert(alert) {
  const fromJoin = (alert.Agents || []).map((a) => a.Name).filter(Boolean);
  if (fromJoin.length) return fromJoin;
  return [];
}

/**
 * Liste tablosu için birincil / ikincil özet satırları.
 */
export function buildAlertScopeSummary(alert, { scriptsById = {}, workflowsById = {} } = {}) {
  const type = alert.NotificationType;
  const agents = agentNamesFromAlert(alert);
  const disabled = !parseAlertEnabled(alert.Enabled);
  const statusLine = disabled
    ? "Uyarı pasif — bildirim gönderilmez"
    : notifyOnLabel(type, alert.NotifyOn);

  if (type === NotificationTypes.AGENT) {
    const primary = agents.length ? agents.join(", ") : "Agent seçilmedi";
    return {
      typeLabel: alertTypeLabel(type),
      typeColor: alertTypeColor(type),
      scopePrimary: primary,
      scopeSecondary: `${statusLine} · Bağlantı kopunca / bağlanınca`,
    };
  }

  if (type === NotificationTypes.WORKFLOW) {
    const ids = workflowIdsFromAlert(alert);
    const labels = ids.map((id) => workflowsById[id] || `Workflow #${id}`);
    const primary = labels.length ? labels.join(", ") : "Workflow seçilmedi";
    return {
      typeLabel: alertTypeLabel(type),
      typeColor: alertTypeColor(type),
      scopePrimary: primary,
      scopeSecondary: statusLine,
    };
  }

  if (type === NotificationTypes.TASK) {
    const scriptIds = scriptIdsFromAlert(alert);
    const scriptNames = scriptIds
      .map((id) => scriptsById[id] || (alert.Script && alert.Script.Id === id ? alert.Script.Name : null))
      .filter(Boolean);
    const uniqueScripts = [...new Set(scriptNames)];
    let primary = uniqueScripts.length ? uniqueScripts.join(", ") : alert.Script?.Name || "Script seçilmedi";
    if (scriptIds.length > 1 && uniqueScripts.length) {
      primary = `${uniqueScripts.length} script: ${primary}`;
    }
    const agentPart = agents.length ? agents.join(", ") : "Tüm agentlar";
    return {
      typeLabel: alertTypeLabel(type),
      typeColor: alertTypeColor(type),
      scopePrimary: primary,
      scopeSecondary: `${statusLine} · Agent: ${agentPart}`,
    };
  }

  return {
    typeLabel: alertTypeLabel(type),
    typeColor: alertTypeColor(type),
    scopePrimary: "—",
    scopeSecondary: statusLine,
  };
}
